import { ShopToGiveTermsCheckboxCard } from '../../../components/molecules/ShopToGiveTermsCheckboxCard/ShopToGiveTermsCheckboxCard';
import { useUserTokenExFormContext } from './FormContext';

export const AgreeToTerms = () => {
  const form = useUserTokenExFormContext();

  return (
    <ShopToGiveTermsCheckboxCard
      checkboxFieldProps={form.getInputProps('terms', { type: 'checkbox' })}
    />
  );
};
